import React from "react";
import PricingClasses from "./Pricing.module.css";
import Layout from "Components/Layouts/Common/common";
function pricing() {
    const pricing1 = [
        {
            name: "Basic Individual Tax Return (1040)",
            federal: "$34.99",
            state: "$39.99",
            city: "$19.99",
            total: "$94.97",
        },
        {
            name: "Non-Resident Tax Return (1040-NR)",
            federal: "$34.99",
            state: "$39.99",
            city: "$19.99",
            total: "$94.97",
        },
        {
            name: "Amendment Tax Return",
            federal: "-",
            state: "-",
            city: "-",
            total: "$100",
        },
        {
            name: "ITIN Application (Form W-7)",
            federal: "-",
            state: "-",
            city: "-",
            total: "$175",
        },
        { name: "Election", federal: "-", state: "-", city: "-", total: "$75" },
        {
            name: "Itemize Deduction",
            federal: "-",
            state: "-",
            city: "-",
            total: "$50",
        },
        {
            name: "FBAR Filing (FinCEN Form 114)",
            federal: "-",
            state: "-",
            city: "-",
            total: "Free",
        },
        { name: "FATCA", federal: "-", state: "-", city: "-", total: "$50" },
        {
            name: "Schedule E (US Rental)",
            federal: "-",
            state: "-",
            city: "-",
            total: "$125",
        },
        {
            name: "Schedule C",
            federal: "-",
            state: "-",
            city: "-",
            total: "$150",
        },
        {
            name: "Electric Credit",
            federal: "-",
            state: "-",
            city: "-",
            total: "$45",
        },
    ];
    const pricing2 = [
        { name: "Business Tax Return (Single Mem LLC)", price: "250" },
        { name: "Partnership Tax Return", price: "350" },
        { name: "Corporate Tax Returns (1120/1120S)", price: "500" },
        {
            name: "Annual Franchise Tax Filing",
            price: "80 + (State Fee If Applicable)",
        },
        { name: "New Business Registration", price: "299* + (State Fee)" },
    ];

    return (
        <Layout>
            <div className={PricingClasses["Container"]}>
                <header>
                    <h3>Pricing</h3>
                    <h4>
                        Transparent Pricing for All Your Tax and Accounting
                        Needs
                    </h4>
                    <p>
                        At <b>Serene Tax</b>, we believe in providing
                        affordable, high-quality services with no hidden fees.
                        Our pricing is straightforward, ensuring you know
                        exactly what to expect. Whether you’re an individual or
                        a business, we have a plan tailored to your needs.
                    </p>
                </header>
            </div>
            <div className={PricingClasses["Pricing"]}>
                <h3>Individual Tax Services</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Service</th>
                            <th style={{ textAlign: "center" }}>Federal</th>
                            <th style={{ textAlign: "center" }}>State</th>
                            <th style={{ textAlign: "center" }}>City</th>
                            <th style={{ textAlign: "center" }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pricing1.map((item) => (
                            <tr key={item.name}>
                                <td>{item.name}</td>
                                <td style={{ textAlign: "center" }}>
                                    {item?.federal}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {item?.state}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {item?.city}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {item?.total}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className={PricingClasses["Pricing"]}>
                <h3>Business Tax Services</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Service</th>
                            <th style={{ textAlign: "center" }}>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pricing2.map((item) => (
                            <tr>
                                <td>{item.name}</td>
                                <td style={{ textAlign: "center" }}>
                                    $ {item?.price}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {/* <div className={PricingClasses["Pricing"]}>
                <h3>Accounting and Payroll Services </h3>
                <table>
                    <thead>
                        <tr>
                            <th>Service</th>
                            <th style={{ textAlign: "center" }}>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pricing3.map((item) => (
                            <tr>
                                <td>{item.name}</td>
                                <td style={{ textAlign: "center" }}>
                                    $ {item?.price}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div> */}
        </Layout>
    );
}

export default pricing;
